import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Marquee } from '@sorare/core/src/atoms/container/Marquee';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { NewSeasonLogo } from '@sorare/core/src/components/Season2026/NewSeasonLogo';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

import careers from '../assets/careers.webp';
import { ImageSection, ResetFontSizeContainer } from '../ui';

const CareersTitle = styled(BrandM)`
  position: absolute;
  bottom: 30%;
  line-height: 0;
  font-size: calc(var(--unit) * 4);
  z-index: 5;
  color: var(--c-white);
  @media ${tabletAndAbove} {
    bottom: 25%;
    font-size: calc(var(--unit) * 8);
  }
  @media ${laptopAndAbove} {
    bottom: 5%;
    line-height: 1;
    font-size: calc(var(--unit) * 12);
  }
`;

const CareersSection = styled(ImageSection)`
  aspect-ratio: 18/6;
  background-image: url(${careers});
`;

const MarqueeContainer = styled.div`
  bottom: 0;
  position: absolute;
  width: var(--100vw);
`;

const MarqueeInnerContainer = styled(Horizontal).attrs({
  center: true,
})`
  padding: 0 var(--intermediate-unit);
`;

const ButtonWrapper = styled.div`
  margin: var(--quadruple-unit) var(--intermediate-unit);
  max-width: 200px;
`;

export const Careers = () => {
  return (
    <ResetFontSizeContainer>
      <CareersSection
        vAlignContent="bottom"
        blackLayer="bottom"
        keepImageOnMobile
      >
        <CareersTitle as="h1">Careers</CareersTitle>
        <MarqueeContainer>
          <Marquee gap={0} duration="25s" stretch>
            <MarqueeInnerContainer gap={1}>
              <NewSeasonLogo size="small" iconSize={4} gap="small" />
              <BrandM>Scout. Play. Win.</BrandM>
            </MarqueeInnerContainer>
          </Marquee>
        </MarqueeContainer>
      </CareersSection>
      <ButtonWrapper>
        <Button color="primary" size="large" to="#jobs">
          View job openings
        </Button>
      </ButtonWrapper>
    </ResetFontSizeContainer>
  );
};
